import script from "./AddHotel.vue?vue&type=script&setup=true&lang=js"
export * from "./AddHotel.vue?vue&type=script&setup=true&lang=js"

import "./AddHotel.vue?vue&type=style&index=0&id=1a0d74e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0d74e4"]])

export default __exports__